import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center p-4 mt-6">
      <p>© 2026 Laurence Klein - Digital Systems | Customer Experience | Process Improvement</p>
    </footer>
  );
}

export default Footer;
